'use client';

import { usePathname } from 'next/navigation';

import {
  EmailShareButton,
  FacebookShareButton,
  XShareButton,
  WhatsappShareButton,
} from 'react-share';

import { Container, Icons, Icon, IconWrap, Label } from './social-share.elements';

import {
  IconMail as Email,
  IconBrandFacebook as Facebook,
  IconBrandX as X,
  IconBrandWhatsapp as Whatsapp,
} from '@tabler/icons-react';

const SocialShare = ({ title }) => {
  const pathname = usePathname();

  return (
    <Container>
      <Label>Podijeli</Label>
      <Icons>
        <Icon>
          <EmailShareButton url={process.env.SITE_URL + pathname} subject={title}>
            <IconWrap>
              <Email size={34} />
            </IconWrap>
          </EmailShareButton>
        </Icon>
        <Icon>
          <FacebookShareButton url={process.env.SITE_URL + pathname}>
            <IconWrap>
              <Facebook size={34} />
            </IconWrap>
          </FacebookShareButton>
        </Icon>
        <Icon>
          <XShareButton url={process.env.SITE_URL + pathname} text={title}>
            <IconWrap>
              <X size={34} />
            </IconWrap>
          </XShareButton>
        </Icon>
        <Icon>
          <WhatsappShareButton url={process.env.SITE_URL + pathname} message={title}>
            <IconWrap>
              <Whatsapp size={34} />
            </IconWrap>
          </WhatsappShareButton>
        </Icon>
      </Icons>
    </Container>
  );
};

export { SocialShare };
